import { render, staticRenderFns } from "./BtnToItemDespesa.vue?vue&type=template&id=c76a5456&slot=acoes&slot-scope=data"
import script from "./BtnToItemDespesa.vue?vue&type=script&lang=js"
export * from "./BtnToItemDespesa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports